<template>
    <common-content-spacer height="large">
        <div v-for="(group, i) in ancillaryServiceData.facilityServiceTypesGroups" :key="i">
            <common-content-spacer height="small">
                <!-- id 7 is service id of radiology and its the only servide that has tests thats why we only shot its groups label -->
                <common-page-header v-if="$route.params.serviceId == 7" :heading="group.name" size="small"></common-page-header>
                <checkbox-input
                    :label="'All'"
                    :value="allChecked(group.facilityServiceTypesSubgroups)"
                    @change="selectionAllChanged(group.facilityServiceTypesSubgroups)"
                ></checkbox-input>
                <div class="ancillary-tests-table">
                    <div
                        v-for="(item, index) in group.facilityServiceTypesSubgroups"
                        :key="index"
                        class="ancillary-tests-table--item"
                    >
                        <checkbox-input
                            :label="item.name"
                            :value="checked(item.id)"
                            @change="selectionChanged(item.id)"
                        ></checkbox-input>
                    </div>
                </div>
            </common-content-spacer>
        </div>

        <common-buttons>
            <common-button :label="$t('common.microcopy.save')" type="primary" @click="saveChanges"></common-button>
            <common-button
                :disabled="!checkedValues.length"
                :label="$t('common.microcopy.next')"
                type="primary"
                @click="goToNextLocation"
            ></common-button>
        </common-buttons>
    </common-content-spacer>
</template>

<script>
    import CheckboxInput from 'components/form-inputs/CheckboxInput'
    import cloneDeep from 'lodash.clonedeep'

    export default {
        components: {
            CheckboxInput,
        },

        props: {
            ancillaryServiceData: { type: Object, required: true },
            prefillValues: { type: Array, default: () => [] },
        },

        data() {
            return {
                checkedValues: [],
            }
        },

        methods: {
            checked(id) {
                return this.checkedValues.includes(id)
            },

            allChecked(subGroups) {
                return this.checkIfArrayContainsArray(subGroups)
            },

            selectionChanged(id) {
                if (this.checkedValues.includes(id)) {
                    this.checkedValues.splice(this.checkedValues.indexOf(id), 1)
                } else {
                    this.checkedValues.push(id)
                }

                this.emitEvent({ name: 'ancillary-tests-selection-changed', payload: this.checkedValues })
            },

            selectionAllChanged(subGroups) {
                if (this.checkIfArrayContainsArray(subGroups)) {
                    this.checkedValues = this.checkedValues.filter((el) => !subGroups.map((item) => item.id).includes(el))
                } else {
                    subGroups.forEach((subGroup) => {
                        if (!this.checkedValues.includes(subGroup.id)) {
                            this.checkedValues.push(subGroup.id)
                        }
                    })
                }
                this.emitEvent({ name: 'ancillary-tests-selection-changed', payload: this.checkedValues })
            },

            checkIfArrayContainsArray(array) {
                return array.map((item) => item.id).every((val) => this.checkedValues.includes(val))
            },

            goToNextLocation() {
                this.emitEvent({ name: 'change-location' })
            },

            saveChanges() {
                this.emitEvent({ name: 'ancillary-tests-selection-save' })
            },
        },

        watch: {
            prefillValues(val) {
                this.checkedValues = cloneDeep(val)
            },
        },

        mounted() {
            this.checkedValues = cloneDeep(this.prefillValues)
        },
    }
</script>

<style lang="scss">
    @import 'styles/components/page-elements/ancillary-table/_ancillary-tests-table';
</style>
